import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { 
  Box, 
  Typography, 
  Paper, 
  Grid, 
  Card, 
  CardContent, 
  CircularProgress,
  Divider,
  Collapse, Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogContent,
  TextField
} from '@mui/material';
import CustomButton from '../CommonComponents/CustomButton';
import CustomCheckbox from '../CommonComponents/CustomCheckbox';
import CustomCancelButton from '../CommonComponents/CustomCancelButton';
import CustomLabel from '../CommonComponents/CustomLabel';
import CustomTextField from '../CommonComponents/CustomTextField';
import CustomToast from '../CommonComponents/CustomToast';
import CustomDialogBox from '../CommonComponents/CustomDialogBox';
import AssetTagsRetrieval from "../ConfigPages/Alertsconfig/AssetTagsRetrieval";
import { Radio, Tree } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { setSelectedStores } from '../../store/mainpage_data';
import { 
  getAllProjectsByOrganizationId, 
  updateMultipleProjectVisibility,
  getMapConfiguration,
  saveMapConfiguration,
  updateProjectVisibilityOne,
  getHistoricalData,
  getVisibleProjectsForMap,
  getdevicetags,
  getPlantViewLabelsFromDb,
  baseURL
} from '../../Restclient/datacollection';
import SearchIcon from '../../images/LK_Search';
import '../../../src/cssfiles/MapConfig.css';

const MapConfiguration = () => {
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.logindata.userdetails);
  const organizationData = useSelector((state) => state.logindata.organisationdata);
  const selectedStores = useSelector((state) => state.mainpagedata.selectedStores);
  const treepathselected = useSelector((state) => state.mainpagedata.treepathselected);
  const selectedpath = useSelector((state) => state.mainpagedata.selectedpath);
  const selectedprojectname = useSelector((state) => state.mainpagedata.selectedprojectname);
  const theme = useSelector((state) => state.themedata.theme);
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [showDialog, setShowDialog] = useState(false);
  const [dialogContent, setDialogContent] = useState({ title: '', message: '' });
  const [selectedTagsArray, setSelectedTagsArray] = useState([]);
  const [toast, setToast] = useState({
    open: false,
    title: '',
    message: '',
    type: 'Info'
  });
  const [openToast, setOpenToast] = useState(false);
  const [selectedProjectsCount, setSelectedProjectsCount] = useState(0);
  const [hasChanges, setHasChanges] = useState(false);
  const [defaultZoomState, setDefaultZoomState] = useState('');
  
  const [expandedProject, setExpandedProject] = useState(null);
  const [selectedTag, setSelectedTag] = useState({
    projectid: '',
    tagid: '',
    tagname: '',
    tagunit: '',
    std_tagname: '',
    tagdatatype: ''
  });
  const [selectedAsset, setSelectedAsset] = useState({
    asset_name: '',
    device_id: ''
  });
  const [existingDeviceTagAlarmConfig, setExistingDeviceTagAlarmConfig] = useState(false);
  const [assetData, setAssetData] = useState(null);
  const [assetIsLoading, setAssetIsLoading] = useState(false);
  const [expandedDevices, setExpandedDevices] = useState({});
  const [expandedTagDevices, setExpandedTagDevices] = useState({});
  const [expandedPlantViewProject, setExpandedPlantViewProject] = useState(null);
  const [plantViewLabelsByProject, setPlantViewLabelsByProject] = useState({});
  const [selectedPlantViewLabelsByProject, setSelectedPlantViewLabelsByProject] = useState({});
  const [selectedPlantViewPathsByProject, setSelectedPlantViewPathsByProject] = useState({});
  const [selectedPlantViewTreePathsByProject, setSelectedPlantViewTreePathsByProject] = useState({});
  const [plantViewHierarchyByProject, setPlantViewHierarchyByProject] = useState({});
  const [plantViewLoadingByProject, setPlantViewLoadingByProject] = useState({});
  const [plantViewErrorByProject, setPlantViewErrorByProject] = useState({});
  const [lastPlantViewProjectId, setLastPlantViewProjectId] = useState('');

  // --- Tag Selection Dialog state ---
  const [openTagDialog, setOpenTagDialog] = useState(null); // null | projectId string
  const [dialogTagNameType, setDialogTagNameType] = useState("0"); // "0"=Live, "1"=Historical
  const [dialogSelectedTagKey, setDialogSelectedTagKey] = useState(null); // "DeviceID-TagID"
  const [dialogSelectedTagDetails, setDialogSelectedTagDetails] = useState(null); // {device, tag}
  const [dialogAggregationOption, setDialogAggregationOption] = useState([]);
  const [dialogRightList, setDialogRightList] = useState([]); // tag objects in right panel
  const [dialogRightSelectedIndices, setDialogRightSelectedIndices] = useState([]);
  const [dialogStartDate, setDialogStartDate] = useState(
    new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().split('T')[0]
  );
  const [dialogEndDate, setDialogEndDate] = useState(
    new Date().toISOString().split('T')[0]
  );
  // ----------------------------------

  const availableZoomStates = useMemo(() => {
    const statesFromProjects = projects
      .map((project) => project?.ProjectDetails?.State)
      .filter((state) => typeof state === 'string' && state.trim() !== '')
      .map((state) => state.trim());

    const mergedStates = defaultZoomState && defaultZoomState.trim() !== ''
      ? [...statesFromProjects, defaultZoomState.trim()]
      : statesFromProjects;

    return Array.from(new Set(mergedStates)).sort((a, b) => a.localeCompare(b));
  }, [projects, defaultZoomState]);
  
  const toggleDeviceExpansion = (deviceId) => {
    setExpandedDevices(prev => ({
      ...prev,
      [deviceId]: !prev[deviceId]
    }));
  };
  
  const toggleTagDeviceExpansion = (deviceId) => {
    setExpandedTagDevices(prev => ({
      ...prev,
      [deviceId]: !prev[deviceId]
    }));
  };
  
  const handleToggleProject = (projectId) => {
    setProjects(prevProjects => {
      const updatedProjects = prevProjects.map(project => {
        const currentProjectId = project.ProjectID || project.id;
        if (currentProjectId === projectId) {
          return { 
            ...project, 
            isVisibleOnMap: !project.isVisibleOnMap,
            isVisible: !project.isVisibleOnMap 
          };
        }
        return project;
      });
      setHasChanges(true);
      
      const visibleProjectIds = updatedProjects
        .filter(p => p.isVisibleOnMap)
        .map(p => p.ProjectID || p.ProjectId || p.id);
      
      
      
      return updatedProjects;
    });
  };
  const debugState = () => {
    const tagsByProject = {};
    selectedTagsArray.forEach(tag => {
      tagsByProject[tag.projectid] = tagsByProject[tag.projectid] || [];
      tagsByProject[tag.projectid].push(tag);
    });
  }
  const assetcallback = (res) => {
    
    setAssetData(res);
  };

  const normalizeLabelList = (values) => {
    if (!Array.isArray(values)) {
      return [];
    }

    return Array.from(
      new Map(
        values
          .filter((value) => typeof value === 'string')
          .map((value) => value.trim())
          .filter((value) => value !== '')
          .map((value) => [value.toLowerCase(), value])
      ).values()
    );
  };

  const findTreePathForSelectedLabel = (nodes, selectedLabel, parentPath = []) => {
    if (!Array.isArray(nodes) || !selectedLabel) {
      return [];
    }

    const normalizedTarget = String(selectedLabel).trim().toLowerCase();

    for (const node of nodes) {
      const nodeLabel = typeof node?.label === 'string' ? node.label.trim() : '';
      const currentPath = nodeLabel ? [...parentPath, nodeLabel] : [...parentPath];

      const subdashboardLabels = Array.isArray(node?.subdashboardLabels)
        ? node.subdashboardLabels
            .filter((item) => typeof item === 'string')
            .map((item) => item.trim().toLowerCase())
        : [];
      const groupedMainLabels = Array.isArray(node?.maindashboardWithSubdashboards)
        ? node.maindashboardWithSubdashboards
            .map((item) => item?.label)
            .filter((item) => typeof item === 'string')
            .map((item) => item.trim().toLowerCase())
        : [];
      const groupedSubLabels = Array.isArray(node?.maindashboardWithSubdashboards)
        ? node.maindashboardWithSubdashboards
            .flatMap((item) => (Array.isArray(item?.subDashboards) ? item.subDashboards : []))
            .map((item) => item?.label)
            .filter((item) => typeof item === 'string')
            .map((item) => item.trim().toLowerCase())
        : [];

      if (nodeLabel && nodeLabel.toLowerCase() === normalizedTarget) {
        return currentPath;
      }

      // Recurse into children FIRST so we return the deepest (most specific) org path.
      // If we matched at the parent level before recursing, we would always get just the
      // root node when dashboards are aggregated up the hierarchy.
      const childPath = findTreePathForSelectedLabel(node?.children || [], selectedLabel, currentPath);
      if (childPath.length > 0) {
        return childPath;
      }

      // Only match this node's own dashboard labels if no child path was found.
      if (
        subdashboardLabels.includes(normalizedTarget) ||
        groupedMainLabels.includes(normalizedTarget) ||
        groupedSubLabels.includes(normalizedTarget)
      ) {
        return currentPath;
      }
    }

    return [];
  };

  const findTreePathForSelectedPair = (nodes, mainLabel, subLabel, parentPath = []) => {
    if (!Array.isArray(nodes) || (!mainLabel && !subLabel)) {
      return [];
    }

    const normalizedMain = String(mainLabel || '').trim().toLowerCase();
    const normalizedSub = String(subLabel || '').trim().toLowerCase();

    for (const node of nodes) {
      const nodeLabel = typeof node?.label === 'string' ? node.label.trim() : '';
      const currentPath = nodeLabel ? [...parentPath, nodeLabel] : [...parentPath];

      const childPath = findTreePathForSelectedPair(node?.children || [], mainLabel, subLabel, currentPath);
      if (childPath.length > 0) {
        return childPath;
      }

      const groups = Array.isArray(node?.maindashboardWithSubdashboards)
        ? node.maindashboardWithSubdashboards
        : [];

      for (const group of groups) {
        const groupMain = String(group?.label || '').trim().toLowerCase();
        const subs = Array.isArray(group?.subDashboards) ? group.subDashboards : [];
        const hasSub = subs.some(
          (sub) => String(sub?.label || '').trim().toLowerCase() === normalizedSub
        );

        const mainMatched = !normalizedMain || groupMain === normalizedMain;
        const subMatched = !normalizedSub || hasSub;

        if (mainMatched && subMatched) {
          return currentPath;
        }
      }
    }

    return [];
  };

  const loadPlantViewLabelsForProject = (projectId) => {
    if (!userDetails?.Organizationid || !projectId) {
      return;
    }

    const projectKey = String(projectId);
    const loginProjectId = String(userDetails?.Projectid || '').trim();
    // Always use the logged-in project context for Plant View in project cards.
    // Fall back to card project only when login project is unavailable.
    const queryProjectId = loginProjectId || projectKey;

    if (!queryProjectId) {
      setPlantViewErrorByProject((prev) => ({
        ...prev,
        [projectKey]: 'Unable to resolve Plant View project id',
      }));
      return;
    }

    setPlantViewLoadingByProject((prev) => ({
      ...prev,
      [projectKey]: true,
    }));
    setPlantViewErrorByProject((prev) => ({
      ...prev,
      [projectKey]: '',
    }));

    getPlantViewLabelsFromDb(userDetails.Organizationid, queryProjectId, (response) => {
      if (response?.success) {
        const labels = normalizeLabelList(response.labels || response.data?.labels);

        setPlantViewLabelsByProject((prev) => ({
          ...prev,
          [projectKey]: labels,
        }));
        setPlantViewHierarchyByProject((prev) => ({
          ...prev,
          [projectKey]: Array.isArray(response.labelHierarchy || response.data?.labelHierarchy)
            ? response.labelHierarchy || response.data?.labelHierarchy
            : [],
        }));
      } else {
        setPlantViewErrorByProject((prev) => ({
          ...prev,
          [projectKey]: response?.error || 'Failed to load plant view labels',
        }));
      }

      setPlantViewLoadingByProject((prev) => ({
        ...prev,
        [projectKey]: false,
      }));
    });
  };

  const handlePlantViewLabelToggle = (projectId, label, isSelected, mainLabel = null, nodeTreePath = []) => {
    const projectKey = String(projectId);
    const isSubDashboardToggle = Boolean(mainLabel);
    const trackedLabel = isSubDashboardToggle ? String(mainLabel || '').trim() : String(label || '').trim();
    setLastPlantViewProjectId(projectKey);
    setSelectedPlantViewLabelsByProject((prev) => {
      const currentLabels = Array.isArray(prev[projectKey]) ? prev[projectKey] : [];
      if (isSelected) {
        return {
          ...prev,
          [projectKey]: normalizeLabelList([...currentLabels, trackedLabel]),
        };
      }

      if (isSubDashboardToggle) {
        return prev;
      }

      return {
        ...prev,
        [projectKey]: currentLabels.filter((item) => item.toLowerCase() !== trackedLabel.toLowerCase()),
      };
    });

    // Track [mainDashboardLabel, subDashboardLabel] path for selectedPath when saving
    if (mainLabel) {
      setSelectedPlantViewPathsByProject((prev) => {
        if (isSelected) {
          return { ...prev, [projectKey]: [mainLabel, label] };
        }
        // Clear path only if this sub-dashboard was the one currently stored
        const current = prev[projectKey];
        if (Array.isArray(current) && String(current[1] || '').toLowerCase() === String(label).toLowerCase()) {
          const updated = { ...prev };
          delete updated[projectKey];
          return updated;
        }
        return prev;
      });
    }

    setSelectedPlantViewTreePathsByProject((prev) => {
      const normalizedTreePath = Array.isArray(nodeTreePath)
        ? nodeTreePath
            .filter((item) => typeof item === 'string' && item.trim() !== '')
            .map((item) => item.trim())
        : [];

      if (isSelected && normalizedTreePath.length > 0) {
        return {
          ...prev,
          [projectKey]: normalizedTreePath,
        };
      }

      if (!isSelected && !isSubDashboardToggle) {
        const updated = { ...prev };
        delete updated[projectKey];
        return updated;
      }

      return prev;
    });

    setHasChanges(true);
  };

  const handleExpandPlantViewSelector = (projectId) => {
    setLastPlantViewProjectId(String(projectId));
    if (expandedPlantViewProject === projectId) {
      setExpandedPlantViewProject(null);
      return;
    }

    setExpandedPlantViewProject(projectId);
    loadPlantViewLabelsForProject(projectId);
  };

  const renderPlantHierarchyNode = (node, projectId, depth = 0, nodePath = 'root', parentTreePath = []) => {
    const projectKey = String(projectId);
    const selectedLabels = selectedPlantViewLabelsByProject[projectKey] || [];
    const selectedPath = Array.isArray(selectedPlantViewPathsByProject[projectKey])
      ? selectedPlantViewPathsByProject[projectKey]
      : [];
    const normalizedSelected = selectedLabels.map((item) => String(item).toLowerCase());
    const nodeLabel = typeof node?.label === 'string' ? node.label.trim() : '';
    const currentTreePath = nodeLabel ? [...parentTreePath, nodeLabel] : [...parentTreePath];
    const dashboardGroups = Array.isArray(node?.maindashboardWithSubdashboards)
      ? node.maindashboardWithSubdashboards
      : [];
    const subdashboardLabels = Array.isArray(node?.subdashboardLabels)
      ? node.subdashboardLabels.filter((item) => typeof item === 'string' && item.trim() !== '')
      : [];
    const children = Array.isArray(node?.children) ? node.children : [];

    return (
      <Box key={`${nodePath}-${nodeLabel || 'node'}`} sx={{ ml: depth * 2, mt: 1 }}>
        {nodeLabel && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            <CustomCheckbox
              checked={normalizedSelected.includes(nodeLabel.toLowerCase())}
              onChange={(checked) => handlePlantViewLabelToggle(projectId, nodeLabel, checked, null, currentTreePath)}
              width={16}
              height={16}
            />
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {nodeLabel}
            </Typography>
          </Box>
        )}

        {dashboardGroups.length > 0 ? (
          dashboardGroups.map((group, groupIndex) => {
            const mainLabel = typeof group?.label === 'string' ? group.label.trim() : '';
            const subDashboards = Array.isArray(group?.subDashboards)
              ? group.subDashboards.filter((sub) => typeof sub?.label === 'string' && sub.label.trim() !== '')
              : [];

            return (
              <Box key={`${nodePath}-group-${groupIndex}-${mainLabel || 'group'}`} sx={{ ml: 3, mt: 0.5 }}>
                {mainLabel && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                    <CustomCheckbox
                      checked={normalizedSelected.includes(mainLabel.toLowerCase())}
                      onChange={(checked) => handlePlantViewLabelToggle(projectId, mainLabel, checked, null, currentTreePath)}
                      width={16}
                      height={16}
                    />
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      {mainLabel}
                    </Typography>
                  </Box>
                )}

                {subDashboards.map((sub, subIndex) => (
                  <Box
                    key={`${nodePath}-group-${groupIndex}-sub-${subIndex}-${sub.label}`}
                    sx={{ display: 'flex', alignItems: 'center', gap: 0.75, ml: 3, mt: 0.5 }}
                  >
                    <CustomCheckbox
                      checked={
                        normalizedSelected.includes(sub.label.toLowerCase()) ||
                        (
                          String(selectedPath[0] || '').toLowerCase() === String(mainLabel || '').toLowerCase() &&
                          String(selectedPath[1] || '').toLowerCase() === String(sub.label || '').toLowerCase()
                        )
                      }
                      onChange={(checked) => handlePlantViewLabelToggle(projectId, sub.label, checked, mainLabel, currentTreePath)}
                      width={16}
                      height={16}
                    />
                    <Typography variant="body2">
                      {sub.label}
                    </Typography>
                  </Box>
                ))}
              </Box>
            );
          })
        ) : (
          subdashboardLabels.map((subLabel, index) => (
            <Box
              key={`${nodePath}-sub-${index}-${subLabel}`}
              sx={{ display: 'flex', alignItems: 'center', gap: 0.75, ml: 3, mt: 0.5 }}
            >
              <CustomCheckbox
                checked={normalizedSelected.includes(subLabel.toLowerCase())}
                onChange={(checked) => handlePlantViewLabelToggle(projectId, subLabel, checked, null, currentTreePath)}
                width={16}
                height={16}
              />
              <Typography variant="body2">
                {subLabel}
              </Typography>
            </Box>
          ))
        )}

        {children.map((childNode, index) =>
          renderPlantHierarchyNode(childNode, projectId, depth + 1, `${nodePath}-child-${index}`, currentTreePath)
        )}
      </Box>
    );
  };
 
// Load projects and configuration when component mounts
useEffect(() => {
  if (userDetails && userDetails.Organizationid) {
    
    
    // Fetch projects with saved configuration
    fetchProjects();
    
    // Also load device tags for tag selection
    getdevicetags(userDetails.Projectid, assetcallback);
  } else {
    
  }
}, [userDetails?.Organizationid]); // Only re-run if org ID changes
const fetchProjects = () => {
  setIsLoading(true);
  
  
  
  try {
    // Step 1: Get all projects
    getAllProjectsByOrganizationId(userDetails.Organizationid, (projectsResponse) => {
      
      
      if (projectsResponse.success && Array.isArray(projectsResponse.projects)) {
        let allProjects = projectsResponse.projects;
        
        
        // Step 2: Get saved configuration from CosmosDB
        getMapConfiguration(userDetails.Organizationid, (configResponse) => {
          
          
          let visibilityMap = {};
          let loadedTags = [];
          
          // Initialize all projects as NOT visible by default
          allProjects.forEach(project => {
            const projectId = project.ProjectID || project.ProjectId || project.id;
            if (projectId) {
              visibilityMap[projectId] = false;
            }
          });
          
          // Load saved configuration if it exists
          if (configResponse.success && configResponse.config) {
            
            
            // Load visibility settings from projectSettings
            if (configResponse.config.projectSettings && Array.isArray(configResponse.config.projectSettings)) {
              
              
              configResponse.config.projectSettings.forEach(setting => {
                if (setting.projectId) {
                  // Set visibility
                  visibilityMap[setting.projectId] = setting.isVisibleOnMap === true;
                  
                  // Load tags for this project
                  if (setting.selectedTags && Array.isArray(setting.selectedTags)) {
                    
                    loadedTags = [...loadedTags, ...setting.selectedTags];
                  }
                }
              });
            }
            
            // Fallback: Also load from allSelectedTags if projectSettings didn't have tags
            if (loadedTags.length === 0 && configResponse.config.allSelectedTags && Array.isArray(configResponse.config.allSelectedTags)) {
              
              loadedTags = configResponse.config.allSelectedTags;
            }

            const savedPlantSelections = Array.isArray(configResponse.config.plantViewMapLabelSelections)
              ? configResponse.config.plantViewMapLabelSelections
              : [];

            console.log("[Map Config Load] Loaded plantViewMapLabelSelections from DB:", savedPlantSelections);

            const selectedByProject = {};
            const restoredPathsByProject = {};
            const restoredTreePathsByProject = {};
            savedPlantSelections.forEach((entry) => {
              const key = String(entry?.projectId || '');
              if (!key) {
                return;
              }
              
              // Restore selectedPath for this project
              const restoredPath = Array.isArray(entry?.selectedPath)
                ? entry.selectedPath
                    .filter((s) => typeof s === 'string' && s.trim())
                    .map((s) => s.trim())
                : [];
              
              if (restoredPath.length > 0) {
                restoredPathsByProject[key] = restoredPath;
                // Show only main dashboards in the selected list.
                const mainLabel = String(restoredPath[0] || '').trim();
                selectedByProject[key] = mainLabel ? [mainLabel] : [];
              }

              const restoredTreePath = Array.isArray(entry?.treePathSelected)
                ? entry.treePathSelected
                    .filter((s) => typeof s === 'string' && s.trim())
                    .map((s) => s.trim())
                : [];
              if (restoredTreePath.length > 0) {
                restoredTreePathsByProject[key] = restoredTreePath;
              }
            });

            console.log("[Map Config Load] selectedByProject:", selectedByProject);
            console.log("[Map Config Load] restoredPathsByProject:", restoredPathsByProject);
            console.log("[Map Config Load] restoredTreePathsByProject:", restoredTreePathsByProject);

            setSelectedPlantViewLabelsByProject(selectedByProject);
            setSelectedPlantViewPathsByProject(restoredPathsByProject);
            setSelectedPlantViewTreePathsByProject(restoredTreePathsByProject);

            setDefaultZoomState(configResponse.config.defaultZoomState || '');
            
            
          } else {
            setDefaultZoomState('');
            // console.warn('No saved configuration found, using defaults');
          }

          // Step 3: Process projects with loaded visibility and tags
          const processedProjects = allProjects.map(project => {
            const projectId = project.ProjectID || project.ProjectId || project.id;
            const isVisible = visibilityMap[projectId] === true;
            
            
            
            return {
              ...project,
              isVisibleOnMap: isVisible,
              isVisible: isVisible
            };
          });
          
          // Step 4: Update component state
          
          setProjects(processedProjects);
          setFilteredProjects(processedProjects);
          
          // Step 5: Set loaded tags
          
          setSelectedTagsArray(loadedTags);
          
          // Log loaded tags by project for debugging
          if (loadedTags.length > 0) {
            const tagsByProject = {};
            loadedTags.forEach(tag => {
              tagsByProject[tag.projectid] = tagsByProject[tag.projectid] || [];
              tagsByProject[tag.projectid].push(tag.tagname);
            });
            
          }
          
          // Step 6: Update Redux with visible projects and their tags
          const visibleProjects = processedProjects.filter(p => p.isVisibleOnMap);
          const visibleProjectsWithTags = visibleProjects.map(project => {
            const projectId = project.ProjectID || project.ProjectId || project.id;
            const projectTags = loadedTags.filter(tag => tag.projectid === projectId);
            
            
            return {
              ...project,
              selectedTags: projectTags
            };
          });
          
          
        //   const serializableProjects = visibleProjectsWithTags.map(p => ({
        //   ProjectID: p.ProjectID || p.ProjectId || p.id,
        //   ProjectName: p.ProjectName || p.Projectname,
        //   Projectdetails: p.Projectdetails || {},
        //   isVisibleOnMap: p.isVisibleOnMap,
        //   selectedTags: p.selectedTags || []
        // }));
        // dispatch(setSelectedStores(serializableProjects));
         dispatch(setSelectedStores(visibleProjectsWithTags));
          
          // Reset hasChanges since we just loaded
          setHasChanges(false);
          setIsLoading(false);
          
          // Show success message
          if (visibleProjects.length > 0) {
            showToast(
              'Configuration Loaded', 
              `Loaded ${visibleProjects.length} visible project(s) with ${loadedTags.length} tag(s)`, 
              'Success'
            );
          }
        });
      } else {
        
        setIsLoading(false);
        showToast('Error', 'Failed to load projects', 'Error');
      }
    });
  } catch (error) {
    
    setIsLoading(false);
    showToast('Error', `Error loading projects: ${error.message}`, 'Error');
  }
};
  const projectdata = useSelector((state) => state.logindata.projectdata);
  

const saveChanges = () => {
  if (!userDetails?.Organizationid) {
    showToast('Error', 'User details not available', 'Error');
    return;
  }
  
  setIsLoading(true);
  
  try {
    
    
    // Clean tags — preserve mode and aggregations for historical tags
    const cleanedTags = selectedTagsArray.map(tag => ({
      projectid: tag.projectid,
      tagid: tag.tagid,
      tagname: tag.tagname,
      tagunit: tag.tagunit || '',
      std_tagname: tag.std_tagname || '',
      tagdatatype: tag.tagdatatype || '',
      device_id: tag.device_id,
      device_name: tag.device_name,
      mode: tag.mode || '0',
      aggregations: Array.isArray(tag.aggregations) ? tag.aggregations : [],
      startDate: tag.startDate || null,
      endDate: tag.endDate || null,
      dateRangeISO: tag.dateRangeISO || null
    }));
    
    
    
    // Create project settings with embedded tags
    const projectSettings = projects.map(project => {
      const projectId = project.ProjectID || project.ProjectId || project.id;
      const projectTags = cleanedTags.filter(tag => tag.projectid === projectId);
      
      return {
        projectId,
        isVisibleOnMap: project.isVisibleOnMap || false,
        isVisible: project.isVisibleOnMap || false,
        selectedTags: projectTags
      };
    });
    
    
    
    // Save exactly the project-wise label arrays fetched/selected in this screen.
    const finalPlantViewSelections = [...plantViewSelectionPayload];

    const selectedProjectIds = finalPlantViewSelections
      .filter((entry) => Array.isArray(entry?.selectedLabels) && entry.selectedLabels.length > 0)
      .map((entry) => String(entry?.projectId || ''));

    const preferredProjectId = [
      String(lastPlantViewProjectId || ''),
      String(expandedPlantViewProject || ''),
      ...selectedProjectIds,
    ].find((id) => id && selectedProjectIds.includes(id)) || '';

    const activeProjectSelection = finalPlantViewSelections.find(
      (entry) => String(entry?.projectId || '') === preferredProjectId,
    ) || finalPlantViewSelections.find(
      (entry) => Array.isArray(entry?.selectedLabels) && entry.selectedLabels.length > 0,
    );

    const activeProjectId = String(activeProjectSelection?.projectId || '');

    const resolveMainAndSubFromHierarchy = (nodes, targetLabel) => {
      if (!Array.isArray(nodes) || !targetLabel) {
        return null;
      }

      const normalizedTarget = String(targetLabel).trim().toLowerCase();

      for (const node of nodes) {
        const childResolved = resolveMainAndSubFromHierarchy(node?.children || [], targetLabel);
        if (childResolved?.main && childResolved?.sub) {
          return childResolved;
        }

        const groups = Array.isArray(node?.maindashboardWithSubdashboards)
          ? node.maindashboardWithSubdashboards
          : [];

        for (const group of groups) {
          const mainLabel = String(group?.label || '').trim();
          const normalizedMain = mainLabel.toLowerCase();
          const subDashboards = Array.isArray(group?.subDashboards) ? group.subDashboards : [];

          const matchedSub = subDashboards.find(
            (sub) => String(sub?.label || '').trim().toLowerCase() === normalizedTarget
          );
          if (matchedSub && mainLabel) {
            return {
              main: mainLabel,
              sub: String(matchedSub?.label || '').trim(),
            };
          }

          if (normalizedMain === normalizedTarget && mainLabel) {
            return {
              main: mainLabel,
              sub: '',
            };
          }
        }
      }

      return null;
    };

    const buildProjectLabelSelection = (projectId, selectionEntry) => {
      const projectKey = String(projectId || '');
      const hierarchy = plantViewHierarchyByProject?.[projectKey] || [];
      const selectedDashboardLabels = Array.isArray(selectionEntry?.selectedLabels)
        ? selectionEntry.selectedLabels
        : [];

      let selectedPathForSave = Array.isArray(selectionEntry?.selectedPath)
        ? selectionEntry.selectedPath
            .filter((item) => typeof item === 'string')
            .map((item) => item.trim())
            .filter(Boolean)
        : [];

      // Persist only main dashboard label in selectedPath (sub-dashboard labels must not be saved).
      if (selectedPathForSave.length > 0) {
        selectedPathForSave = [selectedPathForSave[0]];
      }

      if (selectedPathForSave.length === 0) {
        const candidateLabels = selectedDashboardLabels
          .filter((item) => typeof item === 'string' && item.trim() !== '')
          .map((item) => item.trim());

        for (let i = candidateLabels.length - 1; i >= 0; i--) {
          const candidate = candidateLabels[i];
          if (!candidate) continue;

          if (candidate.includes('|||')) {
            const [mainRaw, subRaw] = candidate.split('|||');
            const mainLabel = String(mainRaw || '').trim();
            const subLabel = String(subRaw || '').trim();
            if (mainLabel && subLabel) {
              selectedPathForSave = [mainLabel];
              break;
            }
          }

          const resolved = resolveMainAndSubFromHierarchy(hierarchy, candidate);
          if (resolved?.main) {
            selectedPathForSave = [resolved.main];
            break;
          }
        }
      }

      const selectedMainLabel = selectedPathForSave[0] || '';

      // Save tree path as full array from root to the selected main dashboard node.
      const derivedTreePathFromHierarchy = selectedMainLabel
        ? findTreePathForSelectedLabel(hierarchy, selectedMainLabel)
        : [];
      const fallbackTreePath = Array.isArray(selectionEntry?.treePathSelected)
        ? selectionEntry.treePathSelected
        : selectedPlantViewTreePathsByProject?.[projectKey];
      const derivedTreePath = Array.isArray(derivedTreePathFromHierarchy) && derivedTreePathFromHierarchy.length > 0
        ? derivedTreePathFromHierarchy
        : (Array.isArray(fallbackTreePath)
            ? fallbackTreePath.filter((item) => typeof item === 'string' && item.trim()).map((item) => item.trim())
            : []);

      const projectNameFromSelection = projects.find((project) => {
        const id = String(project?.ProjectID || project?.ProjectId || project?.id || '');
        return id !== '' && id === projectKey;
      })?.ProjectName || projects.find((project) => {
        const id = String(project?.ProjectID || project?.ProjectId || project?.id || '');
        return id !== '' && id === projectKey;
      })?.Projectname || '';

      return {
        projectId: projectKey,
        projectName: projectNameFromSelection,
        treePathSelected: derivedTreePath,
        selectedPath: selectedPathForSave,
        mainDashboardLabels: selectedMainLabel ? [selectedMainLabel] : [],
        subDashboardLabels: [],
        lastUpdated: new Date().toISOString(),
      };
    };

    const projectLabelSelectionsByProject = {};
    finalPlantViewSelections.forEach((entry) => {
      const projectKey = String(entry?.projectId || '');
      if (!projectKey) return;
      const built = buildProjectLabelSelection(projectKey, entry);
      // Save all built entries, even if they have partial data
      projectLabelSelectionsByProject[projectKey] = built;
    });

    console.log("[Map Config Save] plantViewSelectionPayload has projects:", plantViewSelectionPayload.map(e => e.projectId));
    console.log("[Map Config Save] finalPlantViewSelections has projects:", finalPlantViewSelections.map(e => e.projectId));
    console.log("[Map Config Save] projectLabelSelectionsByProject keys:", Object.keys(projectLabelSelectionsByProject));

    const enrichedPlantViewSelections = finalPlantViewSelections.map((entry) => {
      const projectKey = String(entry?.projectId || '');
      const perProject = projectLabelSelectionsByProject[projectKey] || {};
      return {
        projectId: projectKey,
        projectName: perProject?.projectName || '',
        treePathSelected: Array.isArray(perProject?.treePathSelected) ? perProject.treePathSelected : [],
        selectedPath: Array.isArray(perProject?.selectedPath) ? perProject.selectedPath : [],
        lastUpdated: new Date().toISOString(),
      };
    }).filter((entry) => Boolean(entry.projectId));
    
    console.log("[Map Config Save] enrichedPlantViewSelections (after filter):", enrichedPlantViewSelections);

    const activeBuilt = activeProjectId
      ? projectLabelSelectionsByProject[activeProjectId]
      : null;

    const projectLabelSelected = activeBuilt || {
      projectName: selectedprojectname || '',
      treePathSelected: Array.isArray(treepathselected) ? treepathselected : [],
      selectedPath: Array.isArray(selectedpath) ? selectedpath : [],
      lastUpdated: new Date().toISOString(),
    };
    
    const configToSave = {
      organizationId: userDetails.Organizationid,
      projectSettings: projectSettings,
      allSelectedTags: cleanedTags, // Also save flat array for easy loading
      plantViewMapLabelSelections: enrichedPlantViewSelections,
      projectLabelSelectionsByProject,
      projectLabelSelected,
      defaultZoomState: defaultZoomState || '',
      lastSaved: new Date().toISOString()
    };
    
    console.log("[Map Config Save] Saving configuration with plantViewMapLabelSelections:", enrichedPlantViewSelections);
    
    // Call the API
    saveMapConfiguration(
      userDetails.Organizationid, 
      configToSave,
      (response) => {
        console.log("[Map Config Save] Response from API:", response);
        
        if (response && response.success) {
          // Update Redux
          const visibleProjects = projects.filter(p => p.isVisibleOnMap);
          const visibleProjectsWithTags = visibleProjects.map(project => {
            const projectId = project.ProjectID || project.ProjectId || project.id;
            const projectTags = cleanedTags.filter(tag => tag.projectid === projectId);
            
            return {
              ...project,
              selectedTags: projectTags
            };
          });
          
          dispatch(setSelectedStores(visibleProjectsWithTags));
          
          // Trigger map refresh
          setTimeout(() => {
            if (window.refreshMapView && typeof window.refreshMapView === 'function') {
              window.refreshMapView(visibleProjectsWithTags, defaultZoomState || '');
            } else if (window.refreshMapConfig && typeof window.refreshMapConfig === 'function') {
              window.refreshMapConfig();
            }
          }, 500);
          
          setHasChanges(false);
          setIsLoading(false);
          showToast('Success', `Configuration saved: ${visibleProjects.length} projects, ${cleanedTags.length} tags`, 'Success');
        } else {
          setIsLoading(false);
          showToast('Error', `Failed to save: ${response?.error || 'Unknown error'}`, 'Error');
        }
      }
    );
  } catch (error) {
    
    setIsLoading(false);
    showToast('Error', `Error: ${error.message}`, 'Error');
  }
};
const handleTagSelection = (device, tag, isSelected) => {
    if (isSelected) {
      setSelectedTagsArray(prev => {
        const updated = prev.filter(item => 
          !(item.tagid === tag.TagID && item.device_id === device.DeviceID)
        );     
        return updated;
      });
    } else {
      const newTag = {
        projectid: device.ProjectID,
        tagid: tag.TagID,
        tagname: tag.TagName,
        tagunit: tag.Unit || '',
        std_tagname: tag.std_tagname || '',
        tagdatatype: tag.DataType || '',
        device_id: device.DeviceID,
        device_name: device.DeviceName
      };
      
      setSelectedTagsArray(prev => {
        const updated = [...prev, newTag];        
        return updated;
      });
    }
    setHasChanges(true);
  };

  const fetchAssetDataForProject = (projectId) => {
    setAssetIsLoading(true);
    setAssetData(null);
    
    if (!projectId) {
      showToast('Error', 'Invalid project ID', 'Error');
      setAssetIsLoading(false);
      return;
    }
    
    getdevicetags(projectId,(responseData) => {
      const devices = responseData?.data?.devices || responseData?.devices;
      if (responseData && devices) {
        const filteredDevices = devices.filter(
          device => device.ProjectID === projectId
        );
        
        const formattedDevices = filteredDevices.map(device => ({
          ...device,
          tagdetails: Array.isArray(device.tagdetails) ? device.tagdetails.map(tag => ({
            ...tag,
            TagID: tag.TagID || '',
            TagName: tag.TagName || '',
            Unit: tag.Unit || '',
            DataType: tag.DataType || '',
            selectable: true 
          })) : []
        }));
        
        const filteredData = {
          ...responseData,
          data: {
            ...(responseData.data || {}),
            devices: formattedDevices
          }
        };
        
        setAssetData(filteredData);
      } else {
        showToast('Error', 'Invalid asset data received', 'Error');
      }
      setAssetIsLoading(false);
    });
  };
  useEffect(() => {
    if (searchQuery.trim() === '') {
      setFilteredProjects(projects);
    } else {
      const lowercaseQuery = searchQuery.toLowerCase();
      const filtered = projects.filter(project => 
        (project.ProjectName || '').toLowerCase().includes(lowercaseQuery) || 
        (project.ProjectDetails?.Location || '').toLowerCase().includes(lowercaseQuery) ||
        (project.ProjectDetails?.State || '').toLowerCase().includes(lowercaseQuery) ||
        (project.ProjectDetails?.Country || '').toLowerCase().includes(lowercaseQuery)
      );
      setFilteredProjects(filtered);
    }
  }, [projects, searchQuery]);
  useEffect(() => {
    const count = projects.filter(project => project.isVisibleOnMap).length;
    setSelectedProjectsCount(count);
  }, [projects]);
  useEffect(() => {
    if (userDetails && userDetails.Organizationid) {
     // recoverTags();
      fetchProjects();
      getdevicetags(userDetails.Projectid,assetcallback);
    }
  }, [userDetails]);
 
  const handleExpandTagSelector = (projectId) => {
    const project = projects.find(p => p.id === projectId || p.ProjectID === projectId);
    
    if (expandedProject === projectId) {
      setExpandedProject(null);
      setAssetData(null);
      
      setSelectedTag({
        projectid: '',
        tagid: '',
        tagname: '',
        tagunit: '',
        std_tagname: '',
        tagdatatype: ''
      });
      setSelectedAsset({
        asset_name: '',
        device_id: ''
      });
    } else {
      setExpandedProject(projectId);
      fetchAssetDataForProject(project?.ProjectID || projectId);
    }
  };
  
  // ---- Tag Dialog handlers ----
  const handleOpenTagDialog = (projectId) => {
    const existingTags = selectedTagsArray.filter(t => t.projectid === projectId);
    setDialogRightList([...existingTags]);
    setDialogTagNameType("0");
    setDialogSelectedTagKey(null);
    setDialogSelectedTagDetails(null);
    setDialogAggregationOption([]);
    setDialogRightSelectedIndices([]);
    setDialogStartDate(new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().split('T')[0]);
    setDialogEndDate(new Date().toISOString().split('T')[0]);
    setAssetData(null);
    setOpenTagDialog(projectId);
    const project = projects.find(p => (p.ProjectID || p.id) === projectId);
    fetchAssetDataForProject(project?.ProjectID || projectId);
  };

  const handleCloseTagDialog = () => {
    setOpenTagDialog(null);
    setDialogRightList([]);
    setDialogSelectedTagKey(null);
    setDialogSelectedTagDetails(null);
    setDialogAggregationOption([]);
    setDialogRightSelectedIndices([]);
    setDialogStartDate(new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().split('T')[0]);
    setDialogEndDate(new Date().toISOString().split('T')[0]);
    setAssetData(null);
  };

  const handleSaveTagDialog = () => {
    if (!openTagDialog) return;

    const invalidHistoricalTag = dialogRightList.find(
      (tag) =>
        tag.mode === '1' &&
        (!tag.startDate || !tag.endDate || new Date(tag.startDate) > new Date(tag.endDate))
    );
    if (invalidHistoricalTag) {
      showToast('Validation', 'Set a valid start and end date for all historical tags', 'Warning');
      return;
    }

    setSelectedTagsArray(prev => {
      const withoutProject = prev.filter(t => t.projectid !== openTagDialog);
      return [...withoutProject, ...dialogRightList];
    });
    setHasChanges(true);
    handleCloseTagDialog();
  };

  const handleDialogMoveRight = () => {
    if (!dialogSelectedTagDetails) return;
    const { device, tag } = dialogSelectedTagDetails;
    if (dialogTagNameType === "1" && dialogAggregationOption.length === 0) return;
    if (dialogTagNameType === "1") {
      if (!dialogStartDate || !dialogEndDate || new Date(dialogStartDate) > new Date(dialogEndDate)) {
        showToast('Validation', 'Start date must be before end date', 'Warning');
        return;
      }
    }

    if (dialogTagNameType === "0") {
      // Live mode
      const alreadyExists = dialogRightList.some(
        t => t.tagid === tag.TagID && t.device_id === device.DeviceID
      );
      if (!alreadyExists) {
        setDialogRightList(prev => [...prev, {
          projectid: device.ProjectID,
          tagid: tag.TagID,
          tagname: tag.TagName,
          tagunit: tag.Unit || '',
          std_tagname: tag.Alias || '',
          tagdatatype: tag.DataType || '',
          device_id: device.DeviceID,
          device_name: device.DeviceName,
          mode: "0",
          aggregations: [],
          startDate: null,
          endDate: null,
          dateRangeISO: null
        }]);
      }
    } else {
      // Historical mode – add/merge aggregations
      const existingIdx = dialogRightList.findIndex(
        t => t.tagid === tag.TagID && t.device_id === device.DeviceID
      );
      if (existingIdx >= 0) {
        const updated = [...dialogRightList];
        const newAggs = dialogAggregationOption.filter(
          a => !updated[existingIdx].aggregations.includes(a)
        );
        if (newAggs.length > 0) {
          updated[existingIdx] = {
            ...updated[existingIdx],
            mode: "1",
            aggregations: [...updated[existingIdx].aggregations, ...newAggs],
            startDate: dialogStartDate,
            endDate: dialogEndDate,
            dateRangeISO: {
              start: new Date(dialogStartDate).toISOString(),
              end: new Date(dialogEndDate).toISOString()
            }
          };
          setDialogRightList(updated);
        }
      } else {
        setDialogRightList(prev => [...prev, {
          projectid: device.ProjectID,
          tagid: tag.TagID,
          tagname: tag.TagName,
          tagunit: tag.Unit || '',
          std_tagname: tag.Alias || '',
          tagdatatype: tag.DataType || '',
          device_id: device.DeviceID,
          device_name: device.DeviceName,
          mode: "1",
          aggregations: [...dialogAggregationOption],
          startDate: dialogStartDate,
          endDate: dialogEndDate,
          dateRangeISO: {
            start: new Date(dialogStartDate).toISOString(),
            end: new Date(dialogEndDate).toISOString()
          }
        }]);
      }
    }
    setDialogSelectedTagKey(null);
    setDialogSelectedTagDetails(null);
    setDialogAggregationOption([]);
  };

  const handleDialogMoveLeft = () => {
    if (dialogRightSelectedIndices.length === 0) return;
    setDialogRightList(prev =>
      prev.filter((_, i) => !dialogRightSelectedIndices.includes(i))
    );
    setDialogRightSelectedIndices([]);
  };

  const handleDialogAggOption = (value, isChecked) => {
    setDialogAggregationOption(prev =>
      isChecked ? [...prev, value] : prev.filter(v => v !== value)
    );
  };

  const buildDialogTreeData = (assetData) => {
    if (!assetData?.data?.devices) return [];
    return assetData.data.devices.map(device => ({
      key: `device-${device.DeviceID}`,
      title: <span style={{ color: theme === 'dark' ? '#FFFFFF' : '#5B5B5B', fontWeight: 600 }}>{device.DeviceName}</span>,
      selectable: false,
      children: (device.tagdetails || []).map(tag => {
        const nodeKey = `${device.DeviceID}-${tag.TagID}`;
        return {
          key: nodeKey,
          title: (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <CustomCheckbox
                checked={dialogSelectedTagKey === nodeKey}
                onChange={(checked) => {
                  if (checked) {
                    setDialogSelectedTagKey(nodeKey);
                    setDialogSelectedTagDetails({ device, tag });
                  } else {
                    setDialogSelectedTagKey(null);
                    setDialogSelectedTagDetails(null);
                    setDialogAggregationOption([]);
                  }
                }}
                width={16}
                height={16}
              />
              <span style={{ color: theme === 'dark' ? '#FFFFFF' : '#5B5B5B' }}>
                {tag.TagName}{tag.Unit ? ` (${tag.Unit})` : ''}
              </span>
            </div>
          ),
          selectable: false,
          isLeaf: true
        };
      })
    }));
  };
  // ---- End Tag Dialog handlers ----

  const handleSelectAll = () => {
    setProjects(prevProjects => {
      return prevProjects.map(project => ({ 
        ...project, 
        isVisibleOnMap: true 
      }));
    });
    setHasChanges(true);
  };
  
  const handleSelectNone = () => {
    setProjects(prevProjects => {
      return prevProjects.map(project => ({ 
        ...project, 
        isVisibleOnMap: false 
      }));
    });
    setHasChanges(true);
  };
  
  const handleSearchChange = (value) => {
    setSearchQuery(value);
  };

  const handleDefaultZoomStateChange = (event) => {
    setDefaultZoomState(event.target.value);
    setHasChanges(true);
  };
  
  const showConfirmationDialog = (title, message) => {
    setDialogContent({ title, message });
    setShowDialog(true);
  };
  
  const confirmAction = () => {
    if (dialogContent.title.includes('Clear')) {
      handleSelectNone();
    }
    setShowDialog(false);
  };
  
  const showToast = (title, message, type = 'Info') => {
    setToast({
      open: true,
      title,
      message,
      type
    });
    setOpenToast(true);
  };
  
  const handleCloseToast = () => {
    setToast({
      ...toast,
      open: false
    });
    setOpenToast(false);
  };
  
  const getLocationString = (project) => {
    const details = project.ProjectDetails || {};
    const parts = [details.Location, details.State, details.Country]
      .filter(Boolean)
      .join(', ');
    return parts || 'No location specified';
  };
  
  
  const getCardBorder = (isVisible) => {
    if (isVisible) {
      return '8px solid #4CAF50';
    }
    return theme === 'light' ? '8px solid #ccc' : '8px solid #3C3C3C';
  };

  const plantViewSelectionPayload = useMemo(() => {
    const projectKeys = projects
      .map((project) => String(project?.ProjectID || project?.ProjectId || project?.id || '').trim())
      .filter(Boolean);

    console.log("[Map Config] selectedPlantViewLabelsByProject keys:", Object.keys(selectedPlantViewLabelsByProject || {}));
    console.log("[Map Config] selectedPlantViewPathsByProject keys:", Object.keys(selectedPlantViewPathsByProject || {}));
    console.log("[Map Config] plantViewSelectionPayload projectKeys (union):", Array.from(projectKeys));

    return Array.from(new Set(projectKeys))
      .map((projectId) => {
        const rawPath = selectedPlantViewPathsByProject?.[projectId];
        const selectedPath = Array.isArray(rawPath)
          ? rawPath.filter((s) => typeof s === 'string' && s.trim()).map((s) => s.trim())
          : [];
        return {
          projectId,
          projectName: projects.find((project) => String(project?.ProjectID || project?.ProjectId || project?.id || '').trim() === projectId)?.ProjectName
            || projects.find((project) => String(project?.ProjectID || project?.ProjectId || project?.id || '').trim() === projectId)?.Projectname
            || projects.find((project) => String(project?.ProjectID || project?.ProjectId || project?.id || '').trim() === projectId)?.name
            || '',
          selectedLabels: normalizeLabelList(selectedPlantViewLabelsByProject?.[projectId]),
          // Persist [mainDashboardLabel, subDashboardLabel] per project so it
          // can be restored on the next page load without needing the hierarchy.
          selectedPath,
          treePathSelected: Array.isArray(selectedPlantViewTreePathsByProject?.[projectId])
            ? selectedPlantViewTreePathsByProject[projectId]
                .filter((s) => typeof s === 'string' && s.trim())
                .map((s) => s.trim())
            : [],
          lastUpdated: new Date().toISOString(),
        };
      })
      .map((entry) => {
        console.log("[Map Config] plantViewSelectionPayload entry before filter:", entry.projectId, { selectedLabelsCount: entry.selectedLabels.length, selectedPathLength: entry.selectedPath.length });
        return entry;
      })
      .filter((entry) => entry.projectId);
  }, [projects, selectedPlantViewLabelsByProject, selectedPlantViewPathsByProject, selectedPlantViewTreePathsByProject]);
  
  return (
    
    <Box className="map-config-container">
      {/* Toast Message */}
      <CustomToast
        toastTitle={toast.title}
        toastText={toast.message}
        openToast={openToast}
        onClose={handleCloseToast}
        type={toast.type}
        width="400px"
      />
      
      {/* Controls - Now all on the right side */}
      <Box className="controls-container">
        <Grid container spacing={2} justifyContent="flex-end" alignItems="center">
          <Grid item>
            <CustomButton
              buttonText="Select All"
              onClick={handleSelectAll}
              id="select-all-btn"
            />
          </Grid>
          <Grid item>
            <CustomButton
              buttonText="Clear All"
              onClick={() => showConfirmationDialog(
                'Clear All Selections', 
                'Are you sure you want to deselect all projects? This will hide all projects from the map.'
              )}
              id="clear-all-btn"
            />
          </Grid>
          <Grid item>
            <CustomButton
              buttonText="Save Changes"
              onClick={saveChanges}
              id="save-changes-btn"
              disabled={!hasChanges}
            />
          </Grid>
          <Grid item>
            <FormControl size="small" sx={{ minWidth: 220 }}>
              <InputLabel id="default-zoom-state-label">Default Zoom State</InputLabel>
              <Select
                labelId="default-zoom-state-label"
                id="default-zoom-state"
                value={defaultZoomState}
                label="Default Zoom State"
                onChange={handleDefaultZoomStateChange}
              >
                <MenuItem value="" disabled>
                  <em>Select a state</em>
                </MenuItem>
                {availableZoomStates.map((stateName) => (
                  <MenuItem key={stateName} value={stateName}>
                    {stateName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <Box className="search-container">
              <Box className="search-icon-wrapper">
                <SearchIcon color={theme === 'light' ? '#3C3C3C' : '#C1C1C1'} width={36} height={36}/>
              </Box>
              <CustomTextField 
                id="search-projects"
                placeholder="Search projects..."
                width={350}
                onChange={handleSearchChange}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Grey Container for Cards */}
      <Paper className={`projects-paper ${theme}`}>
  {/* Loading or Project Grid */}
  {isLoading ? (
    <Box className="loading-container">
      <CircularProgress className="loading-spinner" />
    </Box>
  ) : (
    <Grid container spacing={3}>
      {filteredProjects.map((project) => (
        <Grid item xs={12} sm={6} md={4} key={project.id}>
          <Card 
            elevation={3}
            className={`project-card ${theme} ${project.isVisibleOnMap ? 'visible' : 'not-visible'}`}
          >
            <Box className="checkbox-wrapper">
              <CustomCheckbox
                checked={project.isVisibleOnMap}
                onChange={() => handleToggleProject( project.ProjectID || project.ProjectId || project.id)}
                width={18}
                height={18}
              />
            </Box>
                  
                  <CardContent className="card-content">
                    <Typography 
                      variant="h6" 
                      component="div" 
                      gutterBottom
                      className={`project-title ${theme}`}
                    >
                      {project.ProjectName || "Unnamed Project"}
                    </Typography>
                    
                    <Typography 
                      variant="body2" 
                      className={`project-location ${theme}`}
                    >
                      <strong>Location:</strong> {getLocationString(project)}
                    </Typography>
                    
                    {project.ProjectDetails?.Latitude && project.ProjectDetails?.Longitude && (
                      <Typography 
                        variant="body2" 
                        className={`project-coordinates ${theme}`}
                      >
                        <strong>Coordinates:</strong> {`${project.ProjectDetails.Latitude}, ${project.ProjectDetails.Longitude}`}
                      </Typography>
                    )}
                    
                    <Divider className="section-divider" />
                    
                    <Typography 
                      variant="subtitle2" 
                      gutterBottom
                      className={`section-title ${theme}`}
                    >
                      Project Details:
                    </Typography>
                    
                    <Box className="details-content">
                      {project.ProjectDetails?.Location && (
                        <Typography 
                          variant="body2"
                          className={`detail-text ${theme}`}
                        >
                          <strong>Address:</strong> {project.ProjectDetails.Location}
                        </Typography>
                      )}
                      
                      {project.ProjectDetails?.State && (
                        <Typography 
                          variant="body2"
                          className={`detail-text ${theme}`}
                        >
                          <strong>State:</strong> {project.ProjectDetails.State}
                        </Typography>
                      )}
                      
                      {project.ProjectDetails?.Country && (
                        <Typography 
                          variant="body2"
                          className={`detail-text ${theme}`}
                        >
                          <strong>Country:</strong> {project.ProjectDetails.Country}
                        </Typography>
                      )}
                      
                      {project.ProjectDetails?.Pin && (
                        <Typography 
                          variant="body2"
                          className={`detail-text ${theme}`}
                        >
                          <strong>PIN:</strong> {project.ProjectDetails.Pin}
                        </Typography>
                      )}
                      
                      {project.ProjectDetails?.Region && (
                        <Typography 
                          variant="body2"
                          className={`detail-text ${theme}`}
                        >
                          <strong>Region:</strong> {project.ProjectDetails.Region}
                        </Typography>
                      )}
                    </Box>
                    
                    {project.isVisibleOnMap && (
                      <Box className="selected-tags-section">
                        <Typography 
                          variant="subtitle2" 
                          className={`tags-section-title ${theme}`}
                        >
                          {selectedTagsArray.some(tag => tag.projectid === (project.ProjectID || project.ProjectId || project.id)) 
                            ? 'Selected Tags:' 
                            : 'No tags selected'}
                        </Typography>
                        
                        
                        {/* If we have selected tags, group them by device */}
                        {selectedTagsArray.some(tag => tag.projectid === (project.ProjectID || project.ProjectId || project.id)) && (
                          <Box className="tags-list-container">
                            {/* Group tags by device */}
                            {Object.entries(
                              selectedTagsArray
                                .filter(tag => tag.projectid === (project.ProjectID || project.ProjectId || project.id))
                                .reduce((acc, tag) => {
                                  acc[tag.device_id] = acc[tag.device_id] || {
                                    device_name: tag.device_name,
                                    tags: []
                                  };
                                  acc[tag.device_id].tags.push(tag);
                                  return acc;
                                }, {})
                            ).map(([deviceId, data], deviceIdx) => {
                              const isDeviceExpanded = expandedTagDevices[deviceId] !== false; 
                              
                              return (
                                <Box key={`device-selected-${deviceIdx}`} className="device-group">
                                  <Box 
                                    className={`device-header ${theme}`}
                                    onClick={() => toggleTagDeviceExpansion(deviceId)}
                                  >
                                    {/* Arrow icon */}
                                    <Box 
                                      component="span" 
                                      className={`arrow-icon ${isDeviceExpanded ? 'expanded' : ''} ${theme}`}
                                    >
                                      ▶
                                    </Box>
                                    
                                    <Typography 
                                      variant="body2" 
                                      className={`device-name ${theme}`}
                                    >
                                      {data.device_name} ({data.tags.length})
                                    </Typography>
                                  </Box>
                                  
                                  {/* Collapsible tags section */}
                                  <Collapse in={isDeviceExpanded}>
                                    <Box className="device-tags-list">
                                      {data.tags.map((tag, tagIdx) => (
                                        <Chip
                                          key={`selected-tag-${deviceIdx}-${tagIdx}`}
                                          label={tag.tagname}
                                          size="small"
                                          className={`tag-chip ${theme}`}
                                          onDelete={() => {
                                            setSelectedTagsArray(prev => 
                                              prev.filter(item => 
                                                !(item.tagid === tag.tagid && item.device_id === tag.device_id)
                                              )
                                            );
                                            setHasChanges(true);
                                          }}
                                        />
                                      ))}
                                    </Box>
                                  </Collapse>
                                </Box>
                              );
                            })}
                          </Box>
                        )}
                      </Box>
                    )}
                    
                    {/* Add Tags Button - opens dialog */}
                    {project.isVisibleOnMap && (
                      <Box className="tag-selection-button" sx={{ mt: 1 }}>
                        <CustomButton
                          buttonText="Add Tags"
                          onClick={() => handleOpenTagDialog(project.ProjectID || project.id)}
                          id={`tags-btn-${project.id}`}
                        />
                      </Box>
                    )}

                    {project.isVisibleOnMap && (
                      <>
                        <Box className="tag-selection-button" sx={{ mt: 1 }}>
                          <CustomButton
                            buttonText={expandedPlantViewProject === (project.ProjectID || project.ProjectId || project.id) ? "Hide Dashboard" : "Select Dashboard"}
                            onClick={() => handleExpandPlantViewSelector(project.ProjectID || project.ProjectId || project.id)}
                            id={`dashboard-btn-${project.id}`}
                          />
                        </Box>

                        <Collapse in={expandedPlantViewProject === (project.ProjectID || project.ProjectId || project.id)}>
                          <Box className="tag-selector-container" sx={{ mt: 1 }}>
                            <Typography
                              variant="subtitle2"
                              className={`tag-selector-title ${theme}`}
                              sx={{ mb: 1 }}
                            >
                              Select dashboard labels from Plant View:
                            </Typography>

                            {plantViewLoadingByProject[String(project.ProjectID || project.ProjectId || project.id)] ? (
                              <Box className="asset-loading-container">
                                <CircularProgress size={24} className="loading-spinner" />
                              </Box>
                            ) : plantViewErrorByProject[String(project.ProjectID || project.ProjectId || project.id)] ? (
                              <Typography variant="body2" color="error">
                                {plantViewErrorByProject[String(project.ProjectID || project.ProjectId || project.id)]}
                              </Typography>
                            ) : (plantViewHierarchyByProject[String(project.ProjectID || project.ProjectId || project.id)] || []).length > 0 ? (
                              <Box>
                                {(plantViewHierarchyByProject[String(project.ProjectID || project.ProjectId || project.id)] || []).map((node, index) =>
                                  renderPlantHierarchyNode(
                                    node,
                                    project.ProjectID || project.ProjectId || project.id,
                                    0,
                                    `project-${project.ProjectID || project.ProjectId || project.id}-node-${index}`
                                  )
                                )}
                              </Box>
                            ) : (
                              <Typography variant="body2" className={`detail-text ${theme}`}>
                                No dashboard hierarchy found for this project.
                              </Typography>
                            )}
                          </Box>
                        </Collapse>
                      </>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}
            
            {filteredProjects.length === 0 && !isLoading && (
              <Grid item xs={12}>
                <Paper className={`no-projects-paper ${theme}`}>
                  <Typography 
                    variant="h6"
                    className={`no-projects-title ${theme}`}
                  >
                    No projects found
                  </Typography>
                  <Typography 
                    variant="body2" 
                    className={`no-projects-text ${theme}`}
                  >
                    Try changing your search criteria or add new projects.
                  </Typography>
                </Paper>
              </Grid>
            )}
          </Grid>
        )}
      </Paper>
      
      <CustomDialogBox
        dialogTitle={dialogContent.title}
        dialogText={dialogContent.message}
        openDialog={showDialog}
        handleCloseDialog={() => setShowDialog(false)}
        handleConfirmDialog={confirmAction}
        confirmText="Confirm"
        cancelText="Cancel"
        type="Warning"
      />

      {/* ========== Add Tags Dialog ========== */}
      <Dialog
        maxWidth="xl"
        open={openTagDialog !== null}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
          handleCloseTagDialog();
        }}
        PaperProps={{
          style: {
            backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF',
            boxShadow: 'none',
            borderRadius: '0px',
          }
        }}
        BackdropProps={{
          style: {
            backgroundColor: theme === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)',
          }
        }}
      >
        <DialogContent>
          {/* Header row */}
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 10 }}>
            <Typography sx={{ color: theme === 'dark' ? '#FFFFFF' : '#5B5B5B', fontSize: 16, fontWeight: 700 }}>
              Add Tags
            </Typography>
            <div style={{ flexGrow: 1 }} />
            <CustomCancelButton
              buttonText="Cancel"
              onClick={() => {
                setDialogRightList(
                  selectedTagsArray.filter(t => t.projectid === openTagDialog)
                );
                handleCloseTagDialog();
              }}
            />
            <div style={{ width: 8 }} />
            <CustomButton
              buttonText="Save"
              onClick={handleSaveTagDialog}
            />
          </div>

          {/* 3-column layout */}
          <div style={{
            width: 900, height: 600,
            backgroundColor: theme === 'dark' ? '#1e1e1e' : '#FFFFFF',
            padding: 16, display: 'flex', flexDirection: 'row', gap: 16
          }}>
            {/* LEFT – Tag tree */}
            <div style={{
              width: '40%', height: 'calc(100% - 16px)',
              backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF',
              padding: 8, display: 'flex', flexDirection: 'column'
            }}>
              <div style={{
                display: 'flex', flexDirection: 'row', marginBottom: 10,
                borderBottom: theme === 'dark' ? '1px solid #3c3c3c' : '1px solid #c1c1c1'
              }}>
                <Typography sx={{ color: theme === 'dark' ? '#FFFFFF' : '#5B5B5B', fontSize: 16, fontWeight: 700 }}>
                  Tags
                </Typography>
              </div>
              <div style={{ overflow: 'auto', flexGrow: 1 }}>
                {assetIsLoading ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                    <CircularProgress size={28} />
                  </Box>
                ) : (
                  <Tree
                    style={{
                      backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF',
                      color: theme === 'dark' ? '#FFFFFF' : '#5B5B5B',
                    }}
                    switcherIcon={<DownOutlined />}
                    selectable={false}
                    treeData={buildDialogTreeData(assetData)}
                  />
                )}
              </div>
            </div>

            {/* MIDDLE – Live/Historical + aggregation + move buttons */}
            <div style={{
              width: '60%', height: 'calc(100% - 32px)',
              padding: 16, display: 'flex', flexDirection: 'column',
              justifyContent: 'center', alignItems: 'center', gap: 16
            }}>
              <Radio.Group
                onChange={e => {
                  setDialogTagNameType(e.target.value);
                  setDialogAggregationOption([]);
                }}
                value={dialogTagNameType}
                buttonStyle="solid"
              >
                <Radio.Button value="0">Live</Radio.Button>
                <Radio.Button value="1">Historical</Radio.Button>
              </Radio.Group>

              <div style={{ display: 'flex', flexDirection: 'row', gap: 8 }}>
                <CustomButton
                  onClick={handleDialogMoveRight}
                  buttonText=">"
                  disabled={
                    dialogSelectedTagKey === null ||
                    (dialogTagNameType === '1' && dialogAggregationOption.length === 0)
                  }
                />
                <CustomButton
                  onClick={handleDialogMoveLeft}
                  buttonText="<"
                  disabled={dialogRightSelectedIndices.length === 0}
                />
              </div>

              {/* Aggregation options – shown only in Historical mode */}
              <div style={{
                backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF',
                padding: 16,
                visibility: dialogTagNameType === '1' ? 'visible' : 'hidden'
              }}>
                {[
                  { value: 'SUM', label: 'SUMMATION' },
                  { value: 'DIFF', label: 'DIFFERENCE' },
                  { value: 'AVG', label: 'AVERAGE' },
                  { value: 'MIN', label: 'MINIMUM' },
                  { value: 'MAX', label: 'MAXIMUM' },
                  { value: 'SVAL', label: 'START VALUE' },
                  { value: 'EVAL', label: 'END VALUE' },
                ].map(({ value, label }) => (
                  <div key={value} style={{ marginBottom: 4 }}>
                    <CustomCheckbox
                      checked={dialogAggregationOption.includes(value)}
                      onChange={val => handleDialogAggOption(value, val)}
                      disabled={dialogSelectedTagKey === null}
                    />
                    <span>&nbsp;&nbsp;</span>
                    <CustomLabel fontWeight={300} fontSize={14} color="var(--PrimaryText)" labelText={label} />
                    <br />
                  </div>
                ))}

                <div style={{ marginTop: 12 }}>
                  <Typography sx={{ fontSize: 13, fontWeight: 600, marginBottom: 1 }}>
                    Date Range
                  </Typography>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <TextField
                      label="Start Date"
                      type="date"
                      size="small"
                      value={dialogStartDate}
                      onChange={(e) => setDialogStartDate(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ max: dialogEndDate }}
                      disabled={dialogTagNameType === '0'}
                    />
                    <Typography sx={{ fontSize: 12 }}>to</Typography>
                    <TextField
                      label="End Date"
                      type="date"
                      size="small"
                      value={dialogEndDate}
                      onChange={(e) => setDialogEndDate(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ min: dialogStartDate }}
                      disabled={dialogTagNameType === '0'}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT – Selected tags */}
            <div style={{
              width: '40%', height: '100%',
              display: 'flex', flexDirection: 'column', gap: 16
            }}>
              <div style={{
                height: 'calc(100% - 16px)', width: 'calc(100% - 16px)',
                backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF', padding: 8
              }}>
                <div style={{
                  display: 'flex', flexDirection: 'row', marginBottom: 10,
                  borderBottom: theme === 'dark' ? '1px solid #3c3c3c' : '1px solid #c1c1c1'
                }}>
                  <Typography sx={{ color: theme === 'dark' ? '#FFFFFF' : '#5B5B5B', fontSize: 16, fontWeight: 700 }}>
                    Selected
                  </Typography>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6, overflow: 'auto', height: 'calc(100% - 48px)' }}>
                  {dialogRightList.length === 0 ? (
                    <Typography sx={{ color: theme === 'dark' ? '#888888' : '#999999', fontSize: 14, fontStyle: 'italic' }}>
                      No tags added yet
                    </Typography>
                  ) : (
                    dialogRightList.map((item, index) => {
                      const label = item.mode === '1' && item.aggregations?.length > 0
                        ? `${item.device_name}.${item.tagname} [${item.aggregations.join(', ')}] ${item.startDate && item.endDate ? `(${item.startDate} to ${item.endDate})` : ''}`
                        : `${item.device_name}.${item.tagname} [Live]`;
                      return (
                        <div key={index} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '2px 0' }}>
                          <CustomCheckbox
                            checked={dialogRightSelectedIndices.includes(index)}
                            onChange={checked => {
                              setDialogRightSelectedIndices(prev =>
                                checked ? [...prev, index] : prev.filter(i => i !== index)
                              );
                            }}
                            width={16}
                            height={16}
                          />
                          <CustomLabel fontWeight={300} fontSize={14} color="var(--PrimaryText)" labelText={label} />
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      {/* ========== End Add Tags Dialog ========== */}
    </Box>
    
  );
};
export default MapConfiguration;